import { defineMessages } from 'react-intl'

import { CHANNEL } from './constants'

export const channelMessages = defineMessages({
  [CHANNEL.SEM]: {
    id: 'coupon.channel.sem',
    defaultMessage: 'SEM'
  },
  [CHANNEL.FACEBOOK]: {
    id: 'coupon.channel.facebook',
    defaultMessage: 'Facebook'
  }
})
